"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var ReactDOM = _interopRequireWildcard(require("react-dom"));
var _rcTable = _interopRequireWildcard(require("rc-table"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _shallowequal = _interopRequireDefault(require("shallowequal"));
var _ykbUtils = require("ykb-utils");
var _filterDropdown = _interopRequireDefault(require("./filterDropdown"));
var _createStore = _interopRequireDefault(require("./createStore"));
var _SelectionBox = _interopRequireDefault(require("./SelectionBox"));
var _SelectionCheckboxAll = _interopRequireDefault(require("./SelectionCheckboxAll"));
var _Column = _interopRequireDefault(require("./Column"));
var _ColumnGroup = _interopRequireDefault(require("./ColumnGroup"));
var _createBodyRow = _interopRequireDefault(require("./createBodyRow"));
var _checkColumnTypeAndStyle = require("./checkColumnTypeAndStyle");
var _util = require("./util");
var _interface = require("./interface");
var _Pagination = _interopRequireDefault(require("../Pagination"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Spin = _interopRequireDefault(require("../Spin"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _warning = _interopRequireDefault(require("./warning"));
var _EmptyView = _interopRequireDefault(require("./components/EmptyView"));
var _StyledTableWrapper = require("./styled/StyledTableWrapper");
var _StyledTable = require("./styled/StyledTable");
var _StyledFooterContentContainer = require("./styled/StyledFooterContentContainer");
var _StyledFilterDropdown = require("./styled/StyledFilterDropdown");
var _StyledSelectionInfo = require("./styled/StyledSelectionInfo");
var _tableHOC = _interopRequireDefault(require("./tableHOC"));
var _maximizeHOC = _interopRequireDefault(require("./maximizeHOC"));
var _ColumnResizable = _interopRequireDefault(require("./ColumnResizable"));
var _excluded = ["style", "className", "showHeader", "locale", "emptyText", "zebra", "onRow", "onRowClick", "onRowDoubleClick", "footer", "theme", "locale", "expandable", "tableClassName", "rowKey", "minHeight", "scroll"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function noop() {}
function stopPropagation(e) {
  e.stopPropagation();
  if (e.nativeEvent.stopImmediatePropagation) {
    e.nativeEvent.stopImmediatePropagation();
  }
}
function getRowSelection(props) {
  return props.rowSelection || {};
}
var defaultPagination = {
  onChange: noop,
  onShowSizeChange: noop,
  showTotal: true
};

/**
 * Avoid creating new object, so that parent component's shouldComponentUpdate
 * can works appropriately。
 */
var emptyObject = {};
var Table = /*#__PURE__*/function (_React$Component) {
  function Table(_props) {
    var _this;
    (0, _classCallCheck2.default)(this, Table);
    _this = _callSuper(this, Table, [_props]);
    (0, _defineProperty2.default)(_this, "CheckboxPropsCache", void 0);
    (0, _defineProperty2.default)(_this, "store", void 0);
    (0, _defineProperty2.default)(_this, "columns", void 0);
    (0, _defineProperty2.default)(_this, "components", void 0);
    (0, _defineProperty2.default)(_this, "row", void 0);
    (0, _defineProperty2.default)(_this, "filteredData", void 0);
    (0, _defineProperty2.default)(_this, "loading", void 0);
    (0, _defineProperty2.default)(_this, "getCheckboxPropsByItem", function (item, index) {
      var rowSelection = getRowSelection(_this.props);
      if (!rowSelection.getCheckboxProps) {
        return {};
      }
      var key = _this.getRecordKey(item, index);
      // Cache checkboxProps
      if (!_this.CheckboxPropsCache[key]) {
        var checkboxProps = _this.CheckboxPropsCache[key] = rowSelection.getCheckboxProps(item);
        (0, _warning.default)(!('checked' in checkboxProps) && !('defaultChecked' in checkboxProps), 'Table', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
      }
      return _this.CheckboxPropsCache[key];
    });
    (0, _defineProperty2.default)(_this, "tableOnRow", function (record, index) {
      var _this$props = _this.props,
        onRow = _this$props.onRow,
        onRowClick = _this$props.onRowClick,
        onRowDoubleClick = _this$props.onRowDoubleClick,
        prefixCls = _this$props.prefixCls;
      var custom = onRow ? onRow(record, index) : {};
      return _objectSpread({
        prefixCls: prefixCls,
        onClick: onRowClick ? onRowClick.bind(null, record, index) : undefined,
        onDoubleClick: onRowDoubleClick ? onRowDoubleClick.bind(null, record, index) : undefined,
        rowKey: _this.getRecordKey(record, index)
      }, custom);
    });
    (0, _defineProperty2.default)(_this, "handleFilter", function (column, nextFilters) {
      var props = _this.props;
      var pagination = _objectSpread({}, _this.state.pagination);
      var filters = _objectSpread(_objectSpread({}, _this.state.filters), {}, (0, _defineProperty2.default)({}, _this.getColumnKey(column), nextFilters));
      // Remove filters not in current columns
      var currentColumnKeys = [];
      (0, _util.treeMap)(_this.columns, function (c) {
        if (!c.children) {
          currentColumnKeys.push(_this.getColumnKey(c));
        }
      });
      Object.keys(filters).forEach(function (columnKey) {
        if (currentColumnKeys.indexOf(columnKey) < 0) {
          delete filters[columnKey];
        }
      });
      if (props.pagination) {
        // Reset current prop
        pagination.current = 1;
        pagination.onChange(pagination.current);
      }
      var newState = {
        pagination: pagination,
        filters: {}
      };
      var filtersToSetState = _objectSpread({}, filters);
      // Remove filters which is controlled
      _this.getFilteredValueColumns().forEach(function (col) {
        var columnKey = _this.getColumnKey(col);
        if (columnKey) {
          delete filtersToSetState[columnKey];
        }
      });
      if (Object.keys(filtersToSetState).length > 0) {
        newState.filters = filtersToSetState;
      }

      // Controlled current prop will not respond user interaction
      if ((0, _typeof2.default)(props.pagination) === 'object' && 'current' in props.pagination) {
        newState.pagination = _objectSpread(_objectSpread({}, pagination), {}, {
          current: _this.state.pagination.current
        });
      }
      _this.setState(newState, function () {
        _this.store.setState({
          selectionDirty: false
        });
        var onChange = _this.props.onChange;
        if (onChange) {
          onChange.apply(null, _this.prepareParamsArguments(_objectSpread(_objectSpread({}, _this.state), {}, {
            selectionDirty: false,
            filters: filters,
            pagination: pagination
          })));
        }
      });
    });
    (0, _defineProperty2.default)(_this, "isCheckboxDisabled", function (row) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var checkboxProps = _this.getCheckboxPropsByItem(row, i);
      return checkboxProps && checkboxProps.disabled;
    });
    (0, _defineProperty2.default)(_this, "handleSelect", function (record, rowIndex, e) {
      var checked = e.target.checked;
      var nativeEvent = e.nativeEvent;
      var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
      var selectedRowKeys = new Set(_this.store.getState().selectedRowKeys.concat(defaultSelection));
      var halfSelectedRowKeys = new Set();
      var key = _this.getRecordKey(record, rowIndex);
      var pivot = _this.state.pivot;
      var rows = _this.getFlatCurrentPageData(_this.props.childrenColumnName);
      var realIndex = rowIndex;
      if (_this.props.expandedRowRender) {
        realIndex = rows.findIndex(function (row) {
          return _this.getRecordKey(row, rowIndex) === key;
        });
      }
      if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
        var _this$props$rowSelect;
        var changeRowKeys = [];
        var direction = Math.sign(pivot - realIndex);
        var dist = Math.abs(pivot - realIndex);
        var step = 0;
        while (step <= dist) {
          var i = realIndex + step * direction;
          step += 1;
          var row = rows[i];
          var rowKey = _this.getRecordKey(row, i);
          var checkboxProps = _this.getCheckboxPropsByItem(row, i);
          if (!checkboxProps.disabled) {
            if (selectedRowKeys.has(rowKey)) {
              if (!checked) {
                // delete and put changeRowKeys
                selectedRowKeys.delete(rowKey);
                changeRowKeys.push(rowKey);
              }
            } else if (checked) {
              selectedRowKeys.add(rowKey);
              changeRowKeys.push(rowKey);
            }
          }
        }
        if (((_this$props$rowSelect = _this.props.rowSelection) === null || _this$props$rowSelect === void 0 ? void 0 : _this$props$rowSelect.checkStrictly) !== true) {
          var _iterator = _createForOfIteratorHelper(_this.getCurrentPageData()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _this$props$expandabl;
              var _row = _step.value;
              if (Array.isArray(
              // @ts-ignore
              _row[((_this$props$expandabl = _this.props.expandable) === null || _this$props$expandabl === void 0 ? void 0 : _this$props$expandabl.childrenColumnName) || 'children'])) {
                var _this$props$expandabl2;
                _this.recursivelyFindHalfSelected(selectedRowKeys, halfSelectedRowKeys, _row, ((_this$props$expandabl2 = _this.props.expandable) === null || _this$props$expandabl2 === void 0 ? void 0 : _this$props$expandabl2.childrenColumnName) || 'children');
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        _this.setState({
          pivot: realIndex
        });
        _this.store.setState({
          selectionDirty: true
        });
        _this.setSelectedRowKeys(Array.from(selectedRowKeys), Array.from(halfSelectedRowKeys), {
          selectWay: 'onSelectMultiple',
          record: record,
          checked: checked,
          changeRowKeys: changeRowKeys,
          nativeEvent: nativeEvent
        });
      } else {
        var _this$props$rowSelect2;
        if (((_this$props$rowSelect2 = _this.props.rowSelection) === null || _this$props$rowSelect2 === void 0 ? void 0 : _this$props$rowSelect2.checkStrictly) !== true) {
          var _this$props$expandabl3;
          _this.recursivelySelect(selectedRowKeys, record, ((_this$props$expandabl3 = _this.props.expandable) === null || _this$props$expandabl3 === void 0 ? void 0 : _this$props$expandabl3.childrenColumnName) || 'children', checked);
          var _iterator2 = _createForOfIteratorHelper(_this.getCurrentPageData()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _this$props$expandabl4;
              var _row2 = _step2.value;
              if (Array.isArray(
              // @ts-ignore
              _row2[((_this$props$expandabl4 = _this.props.expandable) === null || _this$props$expandabl4 === void 0 ? void 0 : _this$props$expandabl4.childrenColumnName) || 'children'])) {
                var _this$props$expandabl5;
                _this.recursivelyFindHalfSelected(selectedRowKeys, halfSelectedRowKeys, _row2, ((_this$props$expandabl5 = _this.props.expandable) === null || _this$props$expandabl5 === void 0 ? void 0 : _this$props$expandabl5.childrenColumnName) || 'children');
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else {
          if (checked) {
            selectedRowKeys.add(key);
          } else {
            selectedRowKeys.delete(key);
          }
        }
        _this.setState({
          pivot: realIndex
        });
        _this.store.setState({
          selectionDirty: true
        });
        _this.setSelectedRowKeys(Array.from(selectedRowKeys), Array.from(halfSelectedRowKeys), {
          selectWay: 'onSelect',
          record: record,
          checked: checked,
          changeRowKeys: void 0,
          nativeEvent: nativeEvent
        });
      }
    });
    (0, _defineProperty2.default)(_this, "handleRadioSelect", function (record, rowIndex, e) {
      var checked = e.target.checked;
      var nativeEvent = e.nativeEvent;
      var key = _this.getRecordKey(record, rowIndex);
      var selectedRowKeys = [key];
      _this.store.setState({
        selectionDirty: true
      });
      // @ts-ignore
      _this.setSelectedRowKeys(selectedRowKeys, [], {
        selectWay: 'onSelect',
        record: record,
        checked: checked,
        changeRowKeys: void 0,
        nativeEvent: nativeEvent
      });
    });
    (0, _defineProperty2.default)(_this, "handleSelectRow", function (selectionKey, index, onSelectFunc) {
      var _this$props$rowSelect3;
      var data = _this.getFlatCurrentPageData(_this.props.childrenColumnName, ((_this$props$rowSelect3 = _this.props.rowSelection) === null || _this$props$rowSelect3 === void 0 ? void 0 : _this$props$rowSelect3.isAllSelectByCheckbox) || null // select first page by pagination or select all data by checkbox
      );
      var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
      var selectedRowKeys = new Set(_this.store.getState().selectedRowKeys.concat(defaultSelection));
      var changeableRowKeys = data.filter(function (item, i) {
        return !_this.getCheckboxPropsByItem(item, i).disabled;
      }).map(function (item, i) {
        return _this.getRecordKey(item, i);
      });
      var changeRowKeys = new Set();
      var selectWay = 'onSelectAll';
      var checked;
      // handle default selection
      switch (selectionKey) {
        case 'all':
          changeableRowKeys.forEach(function (key) {
            if (!selectedRowKeys.has(key)) {
              selectedRowKeys.add(key);
              changeRowKeys.add(key);
            }
          });
          selectWay = 'onSelectAll';
          checked = true;
          break;
        case 'removeAll':
          changeableRowKeys.forEach(function (key) {
            if (selectedRowKeys.has(key)) {
              selectedRowKeys.delete(key);
              changeRowKeys.add(key);
            }
          });
          selectWay = 'onSelectAll';
          checked = false;
          break;
        case 'invert':
          changeableRowKeys.forEach(function (key) {
            if (!selectedRowKeys.has(key)) {
              selectedRowKeys.add(key);
            } else {
              selectedRowKeys.delete(key);
            }
            changeRowKeys.add(key);
            selectWay = 'onSelectInvert';
          });
          break;
        default:
          break;
      }
      _this.store.setState({
        selectionDirty: true
      });
      // when select custom selection, callback selections[n].onSelect
      var rowSelection = _this.props.rowSelection;
      var customSelectionStartIndex = 2;
      if (rowSelection && rowSelection.hideDefaultSelections) {
        customSelectionStartIndex = 0;
      }
      if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
        return onSelectFunc(changeableRowKeys);
      }
      var halfSelectedRowKeys = new Set();
      if ((rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.checkStrictly) !== true) {
        var _iterator3 = _createForOfIteratorHelper(_this.getCurrentPageData()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _this$props$expandabl6;
            var row = _step3.value;
            if (Array.isArray(
            // @ts-ignore
            row[((_this$props$expandabl6 = _this.props.expandable) === null || _this$props$expandabl6 === void 0 ? void 0 : _this$props$expandabl6.childrenColumnName) || 'children'])) {
              var _this$props$expandabl7;
              _this.recursivelyFindHalfSelected(selectedRowKeys, halfSelectedRowKeys, row, ((_this$props$expandabl7 = _this.props.expandable) === null || _this$props$expandabl7 === void 0 ? void 0 : _this$props$expandabl7.childrenColumnName) || 'children');
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      _this.setSelectedRowKeys(Array.from(selectedRowKeys), Array.from(halfSelectedRowKeys), {
        selectWay: selectWay,
        checked: checked,
        changeRowKeys: Array.from(changeRowKeys)
      }, selectionKey === 'all' || selectionKey === 'removeAll');
    });
    (0, _defineProperty2.default)(_this, "handlePageChange", function (current) {
      var props = _this.props;
      var pagination = _objectSpread({}, _this.state.pagination);
      if (current) {
        pagination.current = current;
      } else {
        pagination.current = pagination.current || 1;
      }
      for (var _len = arguments.length, otherArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        otherArguments[_key - 1] = arguments[_key];
      }
      pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
      var newState = {
        pagination: pagination
      };
      // Controlled current prop will not respond user interaction
      if (props.pagination && (0, _typeof2.default)(props.pagination) === 'object' && 'current' in props.pagination) {
        newState.pagination = _objectSpread(_objectSpread({}, pagination), {}, {
          current: _this.state.pagination.current
        });
      }
      _this.setState(newState);
      _this.store.setState({
        selectionDirty: false
      });
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange.apply(null, _this.prepareParamsArguments(_objectSpread(_objectSpread({}, _this.state), {}, {
          selectionDirty: false,
          pagination: pagination
        })));
      }
    });
    (0, _defineProperty2.default)(_this, "renderSelectionBox", function (type, colSpan, rowSpan) {
      return function (_, record, index) {
        var rowKey = _this.getRecordKey(record, index);
        var props = _this.getCheckboxPropsByItem(record, index);
        var handleChange = function handleChange(e) {
          type === 'radio' ? _this.handleRadioSelect(record, index, e) : _this.handleSelect(record, index, e);
        };
        var propsClassName = _this.props.className || '';
        var className = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, propsClassName, true), "editable-cell-".concat(record.key, "-row-selection"), true));
        var obj = {
          children: /*#__PURE__*/React.createElement("span", {
            onClick: stopPropagation
          }, /*#__PURE__*/React.createElement(_SelectionBox.default, (0, _extends2.default)({
            type: type,
            store: _this.store,
            rowIndex: rowKey,
            onChange: handleChange,
            defaultSelection: _this.getDefaultSelection()
          }, props, {
            className: className,
            onFocus: function onFocus(e) {
              _this.props.onInputFocus && _this.props.onInputFocus(record, 'row-selection');
              props.onFocus && props.onFocus(e);
            },
            onBlur: function onBlur() {
              props.onBlur && props.onBlur();
            }
          }))),
          props: {}
        };
        if (typeof colSpan == 'function') {
          obj.props.colSpan = colSpan(record, index);
        }
        if (typeof rowSpan == 'function') {
          obj.props.rowSpan = rowSpan(record, index);
        }
        return obj;
      };
    });
    (0, _defineProperty2.default)(_this, "getRecordKey", function (record, index) {
      var rowKey = _this.props.rowKey;
      var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      (0, _warning.default)(recordKey !== undefined, 'Table', 'Each record in data of table should have a unique `key` prop, ' + 'or set `rowKey` of Table to an unique primary key, ' + 'see https://u.ant.design/table-row-key');
      return recordKey === undefined ? index : recordKey;
    });
    (0, _defineProperty2.default)(_this, "getPopupContainer", function () {
      return ReactDOM.findDOMNode(_this);
    });
    (0, _defineProperty2.default)(_this, "generatePopupContainerFunc", function () {
      var scroll = _this.props.scroll;

      // Use undefined to let rc component use default logic.
      return scroll ? _this.getPopupContainer : function () {
        return (0, _ykbUtils.containerChecker)(_this.getPopupContainer());
      };
    });
    (0, _defineProperty2.default)(_this, "handleRowClassName", function (record, rowIndex) {
      var rowStyle = _this.props.rowStyle;
      var cls;
      if (rowStyle) {
        cls = (0, _classnames.default)(cls, typeof rowStyle === 'function' ? rowStyle(record, rowIndex) : rowStyle);
      }
      return cls;
    });
    (0, _defineProperty2.default)(_this, "handleShowSizeChange", function (current, pageSize) {
      var pagination = _this.state.pagination;
      pagination.onShowSizeChange(current, pageSize);
      var nextPagination = _objectSpread(_objectSpread({}, pagination), {}, {
        pageSize: pageSize,
        current: current
      });
      _this.setState({
        pagination: nextPagination
      });
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange.apply(null, _this.prepareParamsArguments(_objectSpread(_objectSpread({}, _this.state), {}, {
          pagination: nextPagination
        })));
      }
    });
    (0, _defineProperty2.default)(_this, "renderEmpty", function () {
      var _this$props2 = _this.props,
        emptyText = _this$props2.locale.emptyText,
        minHeight = _this$props2.minHeight;
      return /*#__PURE__*/React.createElement(_EmptyView.default, {
        text: emptyText,
        minHeight: minHeight
      });
    });
    (0, _defineProperty2.default)(_this, "renderFooter", function (currentPageData) {
      var _this$props3 = _this.props,
        footer = _this$props3.footer,
        theme = _this$props3.theme,
        maximized = _this$props3.maximized;
      var bottomPagination = _this.renderPagination('bottom');
      if (!bottomPagination && !footer) {
        return null;
      }
      var footerElement = null;
      if (typeof footer == 'function') {
        footerElement = footer(currentPageData);
      } else if (/*#__PURE__*/React.isValidElement(footer)) {
        footerElement = footer;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, bottomPagination, !maximized && footer && /*#__PURE__*/React.createElement(_StyledFooterContentContainer.StyledFooterContentContainer, {
        $hasPagination: !!bottomPagination,
        theme: theme
      }, footerElement));
    });
    (0, _defineProperty2.default)(_this, "renderTable", function (data, prefixCls) {
      var _this$props4 = _this.props,
        style = _this$props4.style,
        className = _this$props4.className,
        showHeader = _this$props4.showHeader,
        locale = _this$props4.locale,
        emptyText = _this$props4.emptyText,
        zebra = _this$props4.zebra,
        onRow = _this$props4.onRow,
        onRowClick = _this$props4.onRowClick,
        onRowDoubleClick = _this$props4.onRowDoubleClick,
        footer = _this$props4.footer,
        theme = _this$props4.theme,
        mergedLocale = _this$props4.locale,
        expandable = _this$props4.expandable,
        tableClassName = _this$props4.tableClassName,
        rowKey = _this$props4.rowKey,
        minHeight = _this$props4.minHeight,
        defaultScroll = _this$props4.scroll,
        restProps = (0, _objectWithoutProperties2.default)(_this$props4, _excluded);
      var scroll = _objectSpread({}, defaultScroll);
      var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false;
      var classString = (0, _classnames.default)(tableClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-").concat(_this.props.size), true), "bordered", _this.props.bordered), "zebra", _this.props.expandedRowRender ? false : zebra), _this.props.colorType, true));
      var columns = _this.renderRowSelection(prefixCls, mergedLocale);
      columns = _this.renderColumnsDropdown(prefixCls, columns, mergedLocale);
      columns = columns.map(function (column, i) {
        var newColumn = _objectSpread({}, column);
        newColumn.key = _this.getColumnKey(newColumn, i);
        return newColumn;
      });
      var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;
      if ('expandIconColumnIndex' in restProps) {
        expandIconColumnIndex = restProps.expandIconColumnIndex;
      }
      return /*#__PURE__*/React.createElement(_rcTable.default, (0, _extends2.default)({
        key: "table"
      }, restProps, {
        scroll: scroll,
        footer: _this.renderFooter
        // @ts-ignore
        ,
        onRow: _this.tableOnRow
        // @ts-ignore
        ,
        components: _this.components,
        prefixCls: prefixCls,
        data: data
        // @ts-ignore
        ,
        columns: columns,
        showHeader: showHeader,
        className: classString,
        rowKey: rowKey,
        expandable: _objectSpread({
          expandIconAsCell: expandIconAsCell,
          expandIcon: function expandIcon(props) {
            if (!props.expandable) return null;
            return /*#__PURE__*/React.createElement("span", {
              className: "".concat(props.prefixCls, "-row-expand-icon"),
              onClick: function onClick(e) {
                props.onExpand(props.record, e);
              }
            }, /*#__PURE__*/React.createElement(_Icon.default, {
              name: props.expanded ? 'minus' : 'plus',
              size: 16
            }));
          },
          expandIconColumnIndex: expandIconColumnIndex
        }, expandable),
        emptyText: emptyText || _this.renderEmpty,
        rowClassName: _this.handleRowClassName
      }));
    });
    var expandedRowRender = _props.expandedRowRender,
      _props$columns = _props.columns,
      _columns = _props$columns === void 0 ? [] : _props$columns;

    //#region warning and deprecated props
    (0, _warning.default)(!('columnsPageRange' in _props || 'columnsPageSize' in _props), 'Table', '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');
    if (_props.onRowClick || _props.onRowDoubleClick) {
      (0, _warning.default)(false, 'Table', '`onRowClick` and `onRowDoubleClick` are deprecated please use onRow => `onClick` and `onDoubleClick`.');
    }
    _columns.forEach(function (column) {
      if (expandedRowRender && column.fixed) {
        (0, _warning.default)(false, 'Table', '`expandedRowRender` and `Column.fixed` are not compatible. Please use one of them at one time.');
      }
      if (column.onCellClick) {
        (0, _warning.default)(false, 'Table', '`onCellClick deprecated please use onCell -> onClick');
      }
    });
    _this.columns = _props.columns || (0, _util.normalizeColumns)(_props.children);
    _this.columns = _props.columns || (0, _util.normalizeColumns)(_props.children);
    _this.columns = _this.checkColumnTypesAndStyle(_this.columns, _props.locale, _props.theme, _props.size);
    var loading = _props.loading;
    if (typeof loading === 'boolean') {
      loading = {
        spinning: loading
      };
    } else if ((0, _typeof2.default)(loading) === 'object') {
      loading = {
        spinning: loading.status,
        text: loading.text
      };
    }
    _this.loading = loading;
    _this.state = _objectSpread(_objectSpread({}, _this.getDefaultSortOrder(_this.columns)), {}, {
      // 减少状态
      filters: _this.getFiltersFromColumns(),
      pagination: _this.getDefaultPagination(_props),
      pivot: undefined
    });
    _this.CheckboxPropsCache = {};
    _this.store = (0, _createStore.default)({
      selectedRowKeys: getRowSelection(_props).selectedRowKeys || [],
      selectionDirty: false,
      halfSelectedRowKeys: []
    });
    _this.createComponents(_props.components);
    return _this;
  }
  (0, _inherits2.default)(Table, _React$Component);
  return (0, _createClass2.default)(Table, [{
    key: "getDefaultSelection",
    value: function getDefaultSelection() {
      var _this2 = this;
      var rowSelection = getRowSelection(this.props);
      if (!rowSelection.getCheckboxProps) {
        return [];
      }
      return this.getFlatData().filter(function (item, rowIndex) {
        return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
      }).map(function (record, rowIndex) {
        return _this2.getRecordKey(record, rowIndex);
      });
    }
  }, {
    key: "getDefaultPagination",
    value: function getDefaultPagination(props) {
      var pagination = (0, _typeof2.default)(props.pagination) === 'object' && props.pagination !== null ? props.pagination : {};
      var current;
      if ('current' in pagination) {
        current = pagination.current;
      } else if ('defaultCurrent' in pagination) {
        current = pagination.defaultCurrent;
      }
      var pageSize;
      if ('pageSize' in pagination) {
        pageSize = pagination.pageSize;
      } else if ('defaultPageSize' in pagination) {
        pageSize = pagination.defaultPageSize;
      }
      var showTotal = true;
      if ('showTotal' in pagination) {
        showTotal = pagination.showTotal;
      }
      var size = 'default';
      if ('size' in pagination) {
        size = pagination.size;
      } else if (this.props.size === 'middle' || this.props.size === 'small') {
        size = 'small';
      }
      return this.hasPagination(props) ? _objectSpread(_objectSpread(_objectSpread({}, defaultPagination), pagination), {}, {
        showTotal: showTotal,
        size: size,
        current: current || 1,
        pageSize: pageSize || 10
      }) : {};
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _nextProps$data;
      if ('loading' in nextProps) {
        var loading = nextProps.loading;
        if (typeof loading === 'boolean') {
          loading = {
            spinning: loading
          };
        } else if ((0, _typeof2.default)(loading) === 'object') {
          loading = {
            spinning: loading.status,
            text: loading.text
          };
        }
        this.loading = loading;
      }
      this.columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);
      this.columns = this.checkColumnTypesAndStyle(this.columns, nextProps.locale, nextProps.theme, nextProps.size);
      if (((_nextProps$data = nextProps.data) === null || _nextProps$data === void 0 ? void 0 : _nextProps$data.length) === 0) {
        this.store.resetSelectedKeys();
        return;
      }
      if ('pagination' in nextProps || 'pagination' in this.props) {
        this.setState(function (previousState) {
          var newPagination = _objectSpread(_objectSpread(_objectSpread({}, defaultPagination), previousState.pagination), nextProps.pagination);
          newPagination.current = newPagination.current || 1;
          newPagination.pageSize = newPagination.pageSize || 10;
          return {
            pagination: nextProps.pagination !== false ? newPagination : emptyObject
          };
        });
      }
      if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
        this.store.setState({
          selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
        });
      } else if (this.props.rowSelection && !nextProps.rowSelection) {
        this.store.setState({
          selectedRowKeys: []
        });
      }
      if ('data' in nextProps && nextProps.data !== this.props.data) {
        this.store.setState({
          selectionDirty: false
        });
      }

      // https://github.com/ant-design/ant-design/issues/10133
      this.CheckboxPropsCache = {};
      if (this.getSortOrderColumns(this.columns).length > 0) {
        var sortState = this.getSortStateFromColumns(this.columns);
        if (sortState.sortColumn !== this.state.sortColumn || sortState.sortOrder !== this.state.sortOrder) {
          this.setState(sortState);
        }
      }
      var filteredValueColumns = this.getFilteredValueColumns(this.columns);
      if (filteredValueColumns.length > 0) {
        var filtersFromColumns = this.getFiltersFromColumns(this.columns);
        var newFilters = _objectSpread({}, this.state.filters);
        Object.keys(filtersFromColumns).forEach(function (key) {
          newFilters[key] = filtersFromColumns[key];
        });
        if (this.isFiltersChanged(newFilters)) {
          this.setState({
            filters: newFilters
          });
        }
      }
      this.createComponents(nextProps.components, this.props.components);
    }
  }, {
    key: "setSelectedRowKeys",
    value: function setSelectedRowKeys(selectedRowKeys, halfSelectedRowKeys, selectionInfo) {
      var _this3 = this;
      var forceRender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var selectWay = selectionInfo.selectWay,
        record = selectionInfo.record,
        checked = selectionInfo.checked,
        changeRowKeys = selectionInfo.changeRowKeys,
        nativeEvent = selectionInfo.nativeEvent;
      var rowSelection = getRowSelection(this.props);
      if (rowSelection && !('selectedRowKeys' in rowSelection)) {
        this.store.setState({
          selectedRowKeys: selectedRowKeys,
          halfSelectedRowKeys: halfSelectedRowKeys
        });
      }
      var data = this.getFlatData(rowSelection.protectChildren);
      if (!rowSelection.onChange && !rowSelection[selectWay]) {
        return;
      }
      var selectedRows = data.filter(
      // @ts-ignore
      function (row, i) {
        return selectedRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
      });
      if (rowSelection.onChange) {
        rowSelection.onChange(selectedRowKeys, selectedRows);
      }
      if (selectWay === 'onSelect' && rowSelection.onSelect) {
        rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
      } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
        var changeRows = data.filter(function (row, i) {
          return changeRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
        });
        rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
      } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
        var _changeRows = data.filter(function (row, i) {
          return changeRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
        });
        rowSelection.onSelectAll(checked, selectedRows, _changeRows);
      } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
        rowSelection.onSelectInvert(selectedRowKeys);
      }
      // just for rerender after select all checkbox select event
      if (forceRender) {
        this.forceUpdate();
      }
    }
  }, {
    key: "hasPagination",
    value: function hasPagination(props) {
      return (props || this.props).pagination !== false && (props || this.props).pagination !== null;
    }
  }, {
    key: "isFiltersChanged",
    value: function isFiltersChanged(filters) {
      var _this4 = this;
      var filtersChanged = false;
      if (Object.keys(filters).length !== Object.keys(this.state.filters).length) {
        filtersChanged = true;
      } else {
        Object.keys(filters).forEach(function (columnKey) {
          if (filters[columnKey] !== _this4.state.filters[columnKey]) {
            filtersChanged = true;
          }
        });
      }
      return filtersChanged;
    }
  }, {
    key: "getSortOrderColumns",
    value: function getSortOrderColumns(columns) {
      return (0, _util.flatFilter)(columns || this.columns || [], function (column) {
        return 'sortOrder' in column;
      });
    }
  }, {
    key: "getFilteredValueColumns",
    value: function getFilteredValueColumns(columns) {
      return (0, _util.flatFilter)(columns || this.columns || [], function (column) {
        return typeof column.filteredValue !== 'undefined';
      });
    }
  }, {
    key: "getFiltersFromColumns",
    value: function getFiltersFromColumns(columns) {
      var _this5 = this;
      var filters = {};
      this.getFilteredValueColumns(columns).forEach(function (col) {
        var colKey = _this5.getColumnKey(col);
        filters[colKey] = col.filteredValue;
      });
      return filters;
    }
  }, {
    key: "getDefaultSortOrder",
    value: function getDefaultSortOrder(columns) {
      var definedSortState = this.getSortStateFromColumns(columns);
      var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
        return column.defaultSortOrder != null;
      })[0];
      if (defaultSortedColumn && !definedSortState.sortColumn) {
        return {
          sortColumn: defaultSortedColumn,
          sortOrder: defaultSortedColumn.defaultSortOrder
        };
      }
      return definedSortState;
    }
  }, {
    key: "getSortStateFromColumns",
    value: function getSortStateFromColumns(columns) {
      // return first column which sortOrder is not falsy
      var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
        return col.sortOrder;
      })[0];
      if (sortedColumn) {
        return {
          sortColumn: sortedColumn,
          sortOrder: sortedColumn.sortOrder
        };
      }
      return {
        sortColumn: null,
        sortOrder: null
      };
    }
  }, {
    key: "getSorterFn",
    value: function getSorterFn(state) {
      var _ref = state || this.state,
        sortOrder = _ref.sortOrder,
        sortColumn = _ref.sortColumn;
      if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
        return;
      }
      return function (a, b) {
        var result = sortColumn.sorter(a, b, sortOrder, sortColumn);
        if (result !== 0) {
          return sortOrder === 'descend' ? -result : result;
        }
        return 0;
      };
    }
  }, {
    key: "isSameColumn",
    value: function isSameColumn(a, b) {
      if (a && b && a.key && a.key === b.key) {
        return true;
      }
      return a === b || (0, _shallowequal.default)(a, b, function (value, other) {
        if (typeof value === 'function' && typeof other === 'function') {
          return value === other || value.toString() === other.toString();
        }
      });
    }
  }, {
    key: "toggleSortOrder",
    value: function toggleSortOrder(column) {
      if (!column.sorter) {
        return;
      }
      var sortDirections = column.sortDirections || this.props.sortDirections;
      var _this$state = this.state,
        sortOrder = _this$state.sortOrder,
        sortColumn = _this$state.sortColumn;
      // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题
      var newSortOrder;
      // 切换另一列时，丢弃 sortOrder 的状态
      if (this.isSameColumn(sortColumn, column) && sortOrder !== undefined) {
        // 按照sortDirections的内容依次切换排序状态
        var methodIndex = sortDirections.indexOf(sortOrder) + 1;
        newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
      } else {
        newSortOrder = sortDirections[0];
      }
      var newState = {
        sortOrder: newSortOrder,
        sortColumn: newSortOrder ? column : null
      };

      // Controlled
      if (this.getSortOrderColumns().length === 0) {
        this.setState(newState);
      }
      var onChange = this.props.onChange;
      if (onChange) {
        onChange.apply(null, this.prepareParamsArguments(_objectSpread(_objectSpread({}, this.state), newState)));
      }
    }
  }, {
    key: "recursivelySelect",
    value: function recursivelySelect(selectedRowKeys, record, childrenColumnName, add) {
      if (!record) {
        return;
      }
      var key = this.getRecordKey(record, 0);
      if (add) {
        if (!this.isCheckboxDisabled(record)) {
          selectedRowKeys.add(key);
        }
      } else {
        selectedRowKeys.delete(key);
      }
      // @ts-ignore
      if (Array.isArray(record[childrenColumnName])) {
        // @ts-ignore
        var _iterator4 = _createForOfIteratorHelper(record[childrenColumnName]),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var row = _step4.value;
            this.recursivelySelect(selectedRowKeys, row, childrenColumnName, add);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "recursivelyFindHalfSelected",
    value: function recursivelyFindHalfSelected(selectedRowKeys, halfSelectedRowKeys, record, childrenColumnName) {
      if (!record) {
        return _interface.SelectionStatus.NOT_SELECTED;
      }
      var key = this.getRecordKey(record, 0);
      var isCurrentSelected = selectedRowKeys.has(key);
      var isAllSelected = true;
      var hasSelected = false;
      // @ts-ignore
      if (Array.isArray(record[childrenColumnName])) {
        // @ts-ignore
        var _iterator5 = _createForOfIteratorHelper(record[childrenColumnName]),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var row = _step5.value;
            var isSelected = this.recursivelyFindHalfSelected(selectedRowKeys, halfSelectedRowKeys, row, childrenColumnName);
            if (isSelected === _interface.SelectionStatus.ALL_SELECTED || isSelected === _interface.SelectionStatus.HALF_SELECTED) {
              hasSelected = true;
            }
            if (isSelected !== _interface.SelectionStatus.ALL_SELECTED) {
              isAllSelected = false;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      } else {
        if (halfSelectedRowKeys.has(key) && !selectedRowKeys.has(key)) {
          halfSelectedRowKeys.delete(key);
        }
        return selectedRowKeys.has(key) ? _interface.SelectionStatus.ALL_SELECTED : _interface.SelectionStatus.NOT_SELECTED;
      }
      if (isAllSelected) {
        selectedRowKeys.add(key);
      } else {
        selectedRowKeys.delete(key);
      }
      if (!isAllSelected && hasSelected) {
        halfSelectedRowKeys.add(key);
      } else if (isCurrentSelected && !isAllSelected) {
        halfSelectedRowKeys.add(key);
      } else if (!isCurrentSelected && isAllSelected) {
        halfSelectedRowKeys.add(key);
      }
      if (!hasSelected) {
        halfSelectedRowKeys.delete(key);
      }
      if (isAllSelected) {
        return _interface.SelectionStatus.ALL_SELECTED;
      } else if (hasSelected) {
        return _interface.SelectionStatus.HALF_SELECTED;
      }
      return _interface.SelectionStatus.NOT_SELECTED;
    }
  }, {
    key: "renderRowSelection",
    value: function renderRowSelection(prefixCls, locale) {
      var _this6 = this;
      var _this$props5 = this.props,
        rowSelection = _this$props5.rowSelection,
        childrenColumnName = _this$props5.childrenColumnName;
      var columns = this.columns.concat();
      if (rowSelection) {
        var data = this.getFlatCurrentPageData(childrenColumnName).filter(function (item, index) {
          if (rowSelection.getCheckboxProps) {
            return !_this6.getCheckboxPropsByItem(item, index).disabled;
          }
          return true;
        });
        var selectionColumnClass = (0, _classnames.default)("".concat(prefixCls, "-selection-column"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-selection-column-custom"), rowSelection.selections));
        var selectionColInternalClass = (0, _classnames.default)("".concat(prefixCls, "-selection-col"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-selection-col-custom"), rowSelection.selections));
        var selectionColumn = (0, _defineProperty2.default)({
          key: 'selection-column',
          render: this.renderSelectionBox(rowSelection.type, rowSelection.colSpan, rowSelection.rowSpan),
          className: selectionColumnClass,
          fixed: rowSelection.fixed,
          width: rowSelection.columnWidth,
          title: rowSelection.columnTitle
        }, _rcTable.INTERNAL_COL_DEFINE, {
          className: selectionColInternalClass
        });
        if (rowSelection.type !== 'radio') {
          var checkboxAllDisabled = data.every(function (item, index) {
            return _this6.getCheckboxPropsByItem(item, index).disabled;
          });
          selectionColumn.title = selectionColumn.title || /*#__PURE__*/React.createElement(_SelectionCheckboxAll.default, {
            store: this.store,
            locale: locale,
            data: data,
            getCheckboxPropsByItem: this.getCheckboxPropsByItem,
            getRecordKey: this.getRecordKey,
            disabled: checkboxAllDisabled,
            prefixCls: prefixCls
            // @ts-ignore
            ,
            onSelect: this.handleSelectRow,
            selections: rowSelection.selections,
            hideDefaultSelections: rowSelection.hideDefaultSelections,
            hideHeaderSelection: rowSelection.hideHeaderSelection,
            getPopupContainer: this.generatePopupContainerFunc()
          });
        }
        if ('fixed' in rowSelection) {
          selectionColumn.fixed = rowSelection.fixed;
        } else if (columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        })) {
          selectionColumn.fixed = 'left';
        }
        if (columns[0] && columns[0].key === 'selection-column') {
          columns[0] = selectionColumn;
        } else {
          columns.unshift(selectionColumn);
        }
      }
      return columns;
    }
  }, {
    key: "getColumnKey",
    value: function getColumnKey(column, index) {
      return column.key || column.dataIndex || index;
    }
  }, {
    key: "getMaxCurrent",
    value: function getMaxCurrent(total) {
      var _this$state$paginatio = this.state.pagination,
        current = _this$state$paginatio.current,
        pageSize = _this$state$paginatio.pageSize;
      if ((current - 1) * pageSize >= total) {
        return Math.floor((total - 1) / pageSize) + 1;
      }
      return current;
    }
  }, {
    key: "isSortColumn",
    value: function isSortColumn(column) {
      var sortColumn = this.state.sortColumn;
      if (!column || !sortColumn) {
        return false;
      }
      return this.getColumnKey(sortColumn) === this.getColumnKey(column);
    }
  }, {
    key: "checkColumnTypesAndStyle",
    value: function checkColumnTypesAndStyle(columns, locale, theme, size) {
      var _this7 = this;
      var _this$props$childrenC = this.props.childrenColumnName,
        childrenColumnName = _this$props$childrenC === void 0 ? 'children' : _this$props$childrenC;
      return (0, _util.treeMap)(columns, function (column) {
        if (typeof column[childrenColumnName] === 'undefined') {
          column = (0, _checkColumnTypeAndStyle.checkColumnType)(column, locale, _this7.props.onInputFocus, theme, size);
          column = (0, _checkColumnTypeAndStyle.checkColumnStyle)(column);
        }
        return column;
      });
    }
  }, {
    key: "nextSortDirection",
    value: function nextSortDirection(sortDirections, current) {
      if (!current) {
        return sortDirections[0];
      }
      return sortDirections[sortDirections.indexOf(current) + 1];
    }
  }, {
    key: "renderColumnsDropdown",
    value: function renderColumnsDropdown(prefixCls, columns, locale) {
      var _this8 = this;
      var data = this.props.data;
      var _this$state2 = this.state,
        sortOrder = _this$state2.sortOrder,
        filters = _this$state2.filters;
      var localData = this.getLocalData(null, true);
      return (0, _util.treeMap)(columns, function (column, i) {
        var key = _this8.getColumnKey(column, i);
        var filterDropdown;
        var sortButton;
        var sortTip;
        var _onHeaderCell = column.onHeaderCell;
        var isSortColumn = _this8.isSortColumn(column);
        if (column.filters && column.filters.length > 0 || column.filterDropdown) {
          var colFilters = key in filters ? filters[key] : [];
          var filterDropdownData = (0, _ykbUtils.isNullOrUndefined)(column.strictFilterOptions) ? localData : data;
          filterDropdown = /*#__PURE__*/React.createElement(_filterDropdown.default, {
            locale: locale,
            column: column,
            selectedKeys: colFilters,
            confirmFilter: _this8.handleFilter,
            prefixCls: "".concat(prefixCls, "-filter"),
            dropdownPrefixCls: "".concat(prefixCls, "-dropdown"),
            getPopupContainer: _this8.generatePopupContainerFunc(),
            key: "filter-dropdown",
            data: filterDropdownData
          });
        }
        if (column.sorter) {
          var sortDirections = column.sortDirections || _this8.props.sortDirections;
          var isAscend = isSortColumn && sortOrder === 'ascend';
          var isDescend = isSortColumn && sortOrder === 'descend';
          var nextSortOrder = _this8.nextSortDirection(sortDirections, isSortColumn ? sortOrder : undefined);
          if (nextSortOrder === 'descend') {
            sortTip = locale.sortDesc;
          } else if (nextSortOrder === 'ascend') {
            sortTip = locale.sortAsc;
          } else {
            sortTip = locale.sortCancel;
          }
          var ascend = sortDirections.indexOf('ascend') !== -1 && /*#__PURE__*/React.createElement(_Icon.default, {
            className: "".concat(prefixCls, "-column-sorter-up ").concat(isAscend ? 'on' : 'off'),
            name: "sort-up",
            size: "xsmall"
          });
          var descend = sortDirections.indexOf('descend') !== -1 && /*#__PURE__*/React.createElement(_Icon.default, {
            className: "".concat(prefixCls, "-column-sorter-down ").concat(isDescend ? 'on' : 'off'),
            name: "sort-down",
            size: "xsmall"
          });
          sortButton = /*#__PURE__*/React.createElement("div", {
            title: locale.sortTitle,
            className: (0, _classnames.default)("".concat(prefixCls, "-column-sorter-inner"), ascend && descend && "".concat(prefixCls, "-column-sorter-inner-full")),
            key: "sorter"
          }, ascend, descend);
          _onHeaderCell = function onHeaderCell(col) {
            var colProps = {};
            // Get original first
            if (column.onHeaderCell) {
              colProps = _objectSpread({}, column.onHeaderCell(col));
            }
            // Add sorter logic
            var onHeaderCellClick = colProps.onClick;
            colProps.onClick = function () {
              _this8.toggleSortOrder(column);
              if (onHeaderCellClick) {
                onHeaderCellClick.apply(void 0, arguments);
              }
            };
            return colProps;
          };
        }
        var headerColumn = /*#__PURE__*/React.createElement("span", {
          key: "title",
          className: "".concat(prefixCls, "-header-column")
        }, /*#__PURE__*/React.createElement("div", {
          className: sortButton ? "".concat(prefixCls, "-column-sorters") : column.ellipsis ? "".concat(prefixCls, "-column-without-sorters") : undefined
        }, /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-column-title")
        }, _this8.renderColumnTitle(column.title)), /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-column-sorter")
        }, sortButton)));
        var titleComponent = !column.sorter || column.showSorterTooltip === false ? /*#__PURE__*/React.createElement("div", null, headerColumn, filterDropdown) : /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-column-sorters-with-tooltip")
        }, /*#__PURE__*/React.createElement(_Tooltip.default, {
          placement: column.sorterTooltipPlacement || 'top',
          overlay: sortTip
        }, headerColumn), filterDropdown);

        // columnResizable.js tarafına gider
        return _objectSpread(_objectSpread({}, column), {}, {
          className: (0, _classnames.default)(column.className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-column-has-actions"), sortButton || filterDropdown), "".concat(prefixCls, "-column-has-filters"), filterDropdown), "".concat(prefixCls, "-column-has-sorters"), sortButton), "".concat(prefixCls, "-column-sort"), isSortColumn && sortOrder), "table-column-".concat(key), true)),
          title: titleComponent,
          onHeaderCell: function onHeaderCell() {
            var _onResize = _this8.props.onResize;
            var defaultHeader = _onHeaderCell && _onHeaderCell(column) || {};
            return _objectSpread(_objectSpread({}, defaultHeader), {}, {
              width: column.width,
              title: column.ellipsis && _this8.renderColumnTitle(column.title),
              resizable: column.resizable || false,
              onResize: function onResize(event, sizeEvent) {
                if (typeof _onResize === 'function') _onResize(event, sizeEvent, i);
              }
            });
          }
        });
      });
    }
  }, {
    key: "renderColumnTitle",
    value: function renderColumnTitle(title) {
      var _this$state3 = this.state,
        filters = _this$state3.filters,
        sortOrder = _this$state3.sortOrder;
      // https://github.com/ant-design/ant-design/issues/11246#issuecomment-405009167
      if (title instanceof Function) {
        return title({
          filters: filters,
          sortOrder: sortOrder
        });
      }
      return title;
    }
  }, {
    key: "getTotalDataWithChildren",
    value: function getTotalDataWithChildren(data) {
      var sum = 0;
      var _iterator6 = _createForOfIteratorHelper(data),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var row = _step6.value;
          sum++;
          // @ts-ignore
          if (Array.isArray(row.children) && row.children.length > 0) {
            // @ts-ignore
            sum += this.getTotalDataWithChildren(row.children);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return sum;
    }
  }, {
    key: "renderPagination",
    value: function renderPagination(paginationPosition) {
      var hasPagination = this.hasPagination();
      var defaultSelection = this.store.getState().selectionDirty ? [] : this.getDefaultSelection();
      var selectedRowKeys = this.store.getState().selectedRowKeys.concat(defaultSelection);
      var hasSelection = selectedRowKeys.length > 0;
      var _this$props6 = this.props,
        theme = _this$props6.theme,
        locale = _this$props6.locale,
        rowSelection = _this$props6.rowSelection,
        showTotal = _this$props6.showTotal;
      if (!hasPagination && !rowSelection && !showTotal || showTotal && paginationPosition === 'top') {
        return null;
      }
      var pagination = this.state.pagination;
      var showTotalCount = showTotal || pagination && pagination.showTotal;
      var showSelectionInfo = hasSelection ? rowSelection ? rowSelection.showSelectionInfo || rowSelection.showSelectionInfo == undefined : true : false;
      var position = pagination.position || 'bottom';
      var localData = this.getLocalData();
      var total = pagination.total || localData.length;
      var selectionTotal = pagination.total || this.getTotalDataWithChildren(localData);
      var showSelection = rowSelection && rowSelection.showText !== false && (position === paginationPosition || position === 'both');
      var showPagination = total > pagination.pageSize && (position === paginationPosition || position === 'both');
      if (!showPagination && (!showSelection || !showSelectionInfo) && !showTotal) {
        return null;
      }
      if (Array.isArray(localData) && localData.length === 0) return null;
      return /*#__PURE__*/React.createElement(_StyledTable.StyledTablePaginationContainer, {
        $position: paginationPosition,
        key: "pagination-container-".concat(paginationPosition),
        theme: theme
      }, /*#__PURE__*/React.createElement(_StyledSelectionInfo.StyledSelectionInfo, null, showSelectionInfo ? locale && locale.selectionInfo && locale.selectionInfo.replace('{count}', selectedRowKeys.length).replace('{total}', selectionTotal.toString()) : showTotalCount && locale && locale.totalText && locale.totalText.replace('{total}', selectionTotal.toString())), showPagination && hasPagination && /*#__PURE__*/React.createElement(_Pagination.default, (0, _extends2.default)({
        key: "pagination-".concat(paginationPosition)
      }, pagination, {
        showTotal: showTotal,
        onChange: this.handlePageChange,
        total: total,
        current: this.getMaxCurrent(total),
        onShowSizeChange: this.handleShowSizeChange
      })));
    }

    // Get pagination, filters, sorter
  }, {
    key: "prepareParamsArguments",
    value: function prepareParamsArguments(state) {
      var pagination = _objectSpread({}, state.pagination);
      // remove useless handle function in Table.onChange
      delete pagination.onChange;
      delete pagination.onShowSizeChange;
      var filters = state.filters;
      var sorter = {};
      if (state.sortColumn && state.sortOrder) {
        sorter.column = state.sortColumn;
        sorter.order = state.sortOrder;
        sorter.field = state.sortColumn.dataIndex;
        sorter.columnKey = this.getColumnKey(state.sortColumn);
      }
      var extra = {
        currentDataSource: this.getLocalData(state)
      };
      return [pagination, filters, sorter, extra];
    }
  }, {
    key: "findColumn",
    value: function findColumn(myKey) {
      var _this9 = this;
      var column;
      (0, _util.treeMap)(this.columns, function (c) {
        if (_this9.getColumnKey(c) === myKey) {
          column = c;
        }
      });
      return column;
    }
  }, {
    key: "getCurrentPageData",
    value: function getCurrentPageData(isClosePagination) {
      var data = this.getLocalData();
      var current;
      var pageSize;
      var state = this.state;
      // 如果没有分页的话，默认全部展示
      if (!this.hasPagination() || !(0, _ykbUtils.isNullOrUndefined)(isClosePagination) && isClosePagination) {
        pageSize = Number.MAX_VALUE;
        current = 1;
      } else {
        pageSize = state.pagination.pageSize;
        current = this.getMaxCurrent(state.pagination.total || data.length);
      }

      // 分页
      // ---
      // 当数据量少于等于每页数量时，直接设置数据
      // 否则进行读取分页数据
      if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
        data = data.filter(function (_, i) {
          return i >= (current - 1) * pageSize && i < current * pageSize;
        });
      }
      return data;
    }
  }, {
    key: "getFlatData",
    value: function getFlatData(protectChildren) {
      return (0, _util.flatArray)({
        data: this.getLocalData(null, false),
        protectChildren: protectChildren
      });
    }
  }, {
    key: "getFlatCurrentPageData",
    value: function getFlatCurrentPageData(childrenColumnName, isClosePagination) {
      return (0, _util.flatArray)({
        data: this.getCurrentPageData(isClosePagination),
        childrenName: childrenColumnName
      });
    }
  }, {
    key: "recursiveSort",
    value: function recursiveSort(data, sorterFn) {
      var _this10 = this;
      var _this$props$childrenC2 = this.props.childrenColumnName,
        childrenColumnName = _this$props$childrenC2 === void 0 ? 'children' : _this$props$childrenC2;
      return data.sort(sorterFn).map(function (item) {
        return item[childrenColumnName] ? _objectSpread(_objectSpread({}, item), {}, (0, _defineProperty2.default)({}, childrenColumnName, _this10.recursiveSort(item[childrenColumnName], sorterFn))) : item;
      });
    }
  }, {
    key: "getLocalData",
    value: function getLocalData(state) {
      var _this11 = this;
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var currentState = state || this.state;
      var data = this.props.data;
      var dataSource = data || [];
      // 优化本地排序

      dataSource = dataSource.slice(0);
      var sorterFn = this.getSorterFn(currentState);
      if (sorterFn) {
        dataSource = this.recursiveSort(dataSource, sorterFn);
      }
      // 筛选
      if (filter && currentState.filters) {
        Object.keys(currentState.filters).forEach(function (columnKey) {
          var col = _this11.findColumn(columnKey);
          if (!col) {
            return;
          }
          var values = currentState.filters[columnKey] || [];
          if (values.length === 0) {
            return;
          }
          var onFilter = col.onFilter;
          dataSource = onFilter ? dataSource.filter(function (record) {
            return values.some(function (v) {
              return onFilter(v, record);
            });
          }) : dataSource;
        });
      }
      return dataSource;
    }
  }, {
    key: "createComponents",
    value: function createComponents() {
      var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var prevComponents = arguments.length > 1 ? arguments[1] : undefined;
      var bodyRow = components && components.body && components.body.row;
      var preBodyRow = prevComponents && prevComponents.body && prevComponents.body.row;
      if (!this.row || bodyRow !== preBodyRow) {
        this.row = (0, _createBodyRow.default)(bodyRow, this.store);
      }
      this.components = _objectSpread(_objectSpread({}, components), {}, {
        header: _objectSpread(_objectSpread({}, components.header), {}, {
          cell: _ColumnResizable.default // header içinde ki cell alanları tekrar boyutlanabilir durumu için ColumnResizable componentine gider.
        }),
        body: _objectSpread(_objectSpread({}, components.body), {}, {
          row: this.row
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this12 = this;
      var _this$props7 = this.props,
        style = _this$props7.style,
        className = _this$props7.className,
        theme = _this$props7.theme,
        showHeader = _this$props7.showHeader,
        zebra = _this$props7.zebra,
        expandedRowRender = _this$props7.expandedRowRender,
        bordered = _this$props7.bordered,
        size = _this$props7.size,
        scroll = _this$props7.scroll,
        isEditMode = _this$props7.isEditMode,
        minHeight = _this$props7.minHeight,
        zIndex = _this$props7.zIndex;
      var data = this.getCurrentPageData();
      return /*#__PURE__*/React.createElement(_StyledTableWrapper.StyledTableWrapper, {
        className: className,
        style: style,
        $withPagination: this.hasPagination() && data && data.length !== 0,
        $loading: this.loading.spinning,
        theme: theme
      }, /*#__PURE__*/React.createElement(_Spin.default, this.loading, this.renderPagination('top'), /*#__PURE__*/React.createElement(_StyledTable.StyledTable, {
        prefixCls: this.props.prefixCls,
        colorType: this.props.colorType,
        size: size,
        bordered: bordered,
        empty: !data.length,
        noHeader: !showHeader,
        zebra: expandedRowRender ? false : zebra,
        theme: theme,
        $isEditMode: isEditMode,
        minHeight: minHeight,
        zIndex: zIndex,
        scroll: scroll
      }, function (prefixCls) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledFilterDropdown.StyledFilterDropdown, {
          prefixCls: prefixCls,
          theme: theme
        }), _this12.renderTable(data, prefixCls));
      })));
    }
  }]);
}(React.Component);
(0, _defineProperty2.default)(Table, "Column", _Column.default);
(0, _defineProperty2.default)(Table, "ColumnGroup", _ColumnGroup.default);
(0, _defineProperty2.default)(Table, "propTypes", {
  data: PropTypes.array,
  columns: PropTypes.array,
  prefixCls: PropTypes.string,
  useFixedHeader: PropTypes.bool,
  rowSelection: PropTypes.object,
  className: PropTypes.string,
  size: PropTypes.string,
  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  bordered: PropTypes.bool,
  onChange: PropTypes.func,
  locale: PropTypes.object,
  sortDirections: PropTypes.array,
  zebra: PropTypes.bool,
  colorType: PropTypes.string,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    disabled: PropTypes.bool,
    current: PropTypes.number,
    defaultCurrent: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
    defaultPageSize: PropTypes.number,
    showTotal: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
  })]),
  theme: PropTypes.object,
  onResize: PropTypes.func,
  minHeight: PropTypes.number,
  zIndex: PropTypes.number
});
(0, _defineProperty2.default)(Table, "defaultProps", {
  data: [],
  colorType: 'default',
  useFixedHeader: false,
  className: '',
  size: 'default',
  loading: false,
  bordered: true,
  indentSize: 20,
  locale: {},
  rowKey: 'key',
  showHeader: true,
  sortDirections: ['ascend', 'descend'],
  zebra: false,
  zIndex: 1,
  expandable: {},
  isEditMode: false
});
var _default = exports.default = (0, _maximizeHOC.default)((0, _tableHOC.default)(Table));